import { TFunction } from "i18next";
import useTranslation from "@babackapp/translations/use-translation";

const validFlowOperations = [
  "returnRequest:returnRequest:create",
  "returnRequest:returnRequest:cancel",
  "returnRequest:treatment:error",
  "returnRequest:logistician:reject",
  "returnRequest:merchant:reject",
  "returnRequest:merchant:treat",
  "returnRequest:merchant:fakeTreat",
  "returnRequest:shopifyreturn:close",
  "returnRequest:logistician:treat",
  "returnRequest:status:update",
  "returnRequest:need:approval",
  // "mail:ticket:gorgias",
  // "mail:ticket:zendesk",
  // "returnRequest:note:shopify",
];

const triggerSubActionsOptions = (t: TFunction<"translation", undefined>) => [
  {
    key: "returnRequest:assignee:update",
    label: t("workflow.module.assigne"),
  },
  {
    key: "returnRequest:merchant:treat",
    label: t("workflow.module.processMerch"),
  },
  {
    key: "returnRequest:merchant:fakeTreat",
    label: t("workflow.module.processFakeMerch"),
  },
  {
    key: "returnRequest:shopifyreturn:close",
    label: t("workflow.module.closeReturn"),
  },
  {
    key: "returnRequest:logistician:treat",
    label: t("workflow.module.processLogi"),
  },
  {
    key: "mail:ticket:zendesk",
    label: t("workflow.module.ticketZendesk"),
  },
  {
    key: "returnRequest:additionnalDetails:shopify",
    label: t("workflow.module.additionnalDetails"),
  },
  {
    key: "mail:ticket:gorgias",
    label: t("workflow.module.ticketGorgias"),
  },
  {
    key: "returnRequest:tag:shopify",
    label: t("workflow.module.tagShopify"),
  },
  {
    key: "returnRequest:note:shopify",
    label: t("workflow.module.noteShopifyTitle"),
  },
];

const flowActionsOptions = (t: TFunction<"translation", undefined>) => [
  {
    key: "returnRequest:returnRequest:create",
    label: t("workflow.module.created"),
  },
  {
    key: "returnRequest:returnRequest:cancel",
    label: t("workflow.module.cancel"),
  },
  {
    key: "returnRequest:logistician:reject",
    label: t("workflow.module.logisticianReject"),
  },
  {
    key: "returnRequest:merchant:reject",
    label: t("workflow.module.merchantReject"),
  },
  {
    key: "returnRequest:logistician:treat",
    label: t("workflow.module.logisticianTreat"),
  },
  {
    key: "returnRequest:status:update",
    label: t("workflow.module.updateStatus"),
  },
  {
    key: "returnRequest:treatment:error",
    label: t("workflow.module.error"),
  },
  {
    key: "returnRequest:need:approval",
    label: t("workflow.module.needApproval"),
  },
];

const actionsUpdateReturnRequestOptions = (
  t: TFunction<"translation", undefined>,
) => [
  {
    key: "created",
    label: t("returnDetail.status.created"),
  },
  {
    key: "approved",
    label: t("returnDetail.status.approved"),
  },
  {
    key: "waiting",
    label: t("returnDetail.status.waiting"),
  },
  {
    key: "shipping",
    label: t("returnDetail.status.shipping"),
  },
  {
    key: "shipped",
    label: t("returnDetail.status.shipped"),
  },
  {
    key: "partiallyTreatedLogistician",
    label: t("returnDetail.status.partiallyTreatedLogistician"),
  },
  {
    key: "treatedLogistician",
    label: t("returnDetail.status.treatedLogistician"),
  },

  {
    key: "partiallyTreatedMerchant",
    label: t("returnDetail.status.partiallyTreatedMerchant"),
  },
  {
    key: "treatedMerchant",
    label: t("returnDetail.status.treatedMerchant"),
  },
];

export const useModuleFlowConstants = () => {
  const t = useTranslation();

  return {
    validFlowOperations,
    triggerSubActionsOptions: triggerSubActionsOptions(t),
    flowActionsOptions: flowActionsOptions(t),
    actionsUpdateReturnRequestOptions: actionsUpdateReturnRequestOptions(t),
  };
};
